<mat-toolbar>
  <img ngSrc="assets/logo.svg" width="250" height="70" alt="TF Agency logo" priority />

  <span class="example-spacer"></span>

  <button mat-icon-button class="icon-button" (click)="openGroupChat()">
    <span class="icon chat"></span>
  </button>
  <button mat-icon-button class="icon-button" [matMenuTriggerFor]="menu">
    <span class="icon accountcircle"></span>
  </button>

  <mat-menu #menu="matMenu">
    <h2 class="p-4 text-dark font-primary text-base font-semibold">
      {{ fullName }}
    </h2>
    <button mat-menu-item [matMenuTriggerFor]="language">
      {{ 'Language' | translate }}
    </button>
    <button mat-menu-item (click)="logoff()">
      <mat-icon>logout</mat-icon>
      <span>{{ 'Log Out' | translate }}</span>
    </button>
  </mat-menu>
  <mat-menu #language="matMenu">
    @for (locale of localesList; track locale) {
      <a mat-menu-item (click)="languageStore.changeLanguage(locale)">
        {{ locale.label }}
      </a>
    }
  </mat-menu>
</mat-toolbar>
<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" class="sidenav navigation" [class.collapsed]="!isCollapsed" opened>
    <mat-nav-list>
      <a mat-list-item [routerLink]="[mainRoutes.dashboardRoute]" routerLinkActive="active-link">
        @if (!isCollapsed) {
          <span class="icon dashboard"></span>
          <p class="!font-primary">{{ 'Dashboard' | translate }}</p>
        } @else {
          <div
            style="display: flex; justify-content: center"
            [matTooltip]="'Dashboard' | translate"
            [matTooltipPosition]="'right'"
          >
            <span class="icon dashboard"></span>
          </div>
        }
      </a>
      <a mat-list-item [routerLink]="[mainRoutes.propertiesRoute]" routerLinkActive="active-link">
        @if (!isCollapsed) {
          <span class="icon stb-properties"></span>
          <p class="!font-primary">{{ 'STB Properties' | translate }}</p>
        } @else {
          <div
            style="display: flex; justify-content: center"
            [matTooltip]="'STB Properties' | translate"
            [matTooltipPosition]="'right'"
          >
            <span class="icon stb-properties"></span>
          </div>
        }
      </a>
      <!-- <a
        mat-list-item
        [routerLink]="[mainRoutes.marketAnalysisRoute]"
        routerLinkActive="active-link"
        >
        @if (!isCollapsed) {
          <span class="icon market-analysis"></span>
          <p class="!font-primary">{{ 'Market Analysis' | translate }}</p>
        } @else {
          <div
            style="display: flex; justify-content: center"
            [matTooltip]="'Market Analysis' | translate"
            [matTooltipPosition]="'right'"
            >
            <span class="icon market-analysis"></span>
          </div>
        }
      </a> -->
      @if (role === RoleType.Admin) {
        <a mat-list-item [routerLink]="[mainRoutes.newsFeedsRoute]" routerLinkActive="active-link">
          @if (!isCollapsed) {
            <span class="icon news-feed"></span>
            {{ 'News feed' | translate }}
          } @else {
            <div
              style="display: flex; justify-content: center"
              [matTooltip]="'News feed' | translate"
              [matTooltipPosition]="'right'"
            >
              <span class="icon news-feed"></span>
            </div>
          }
        </a>
      }
      @if (role === RoleType.Admin || role === RoleType.Assistant) {
        <a mat-list-item [routerLink]="[mainRoutes.assignPropertiesRoute]" routerLinkActive="active-link">
          @if (!isCollapsed) {
            <span class="icon assign-properties"></span>
            <p class="!font-primary">{{ 'Assign Properties' | translate }}</p>
          } @else {
            <div
              style="display: flex; justify-content: center"
              [matTooltip]="'Assign Properties' | translate"
              [matTooltipPosition]="'right'"
            >
              <span class="icon assign-properties"></span>
            </div>
          }
        </a>
      }
      @if (role === RoleType.Admin) {
        <a mat-list-item [routerLink]="[mainRoutes.brokersStaffRoute]" routerLinkActive="active-link">
          @if (!isCollapsed) {
            <span class="icon brokers-staff"></span>
            <p class="!font-primary">{{ 'Brokers & Staff' | translate }}</p>
          } @else {
            <div
              style="display: flex; justify-content: center"
              [matTooltip]="'Brokers & Staff' | translate"
              [matTooltipPosition]="'right'"
            >
              <span class="icon brokers-staff"></span>
            </div>
          }
        </a>
      }
    </mat-nav-list>

    <div class="pointer collaps" (click)="toggleSidenav()">
      @if (!isCollapsed) {
        <div style="display: flex; justify-content: center; padding: 0px 8px" class="left-collapse">
          <span class="icon left-arrow" style="margin-right: 8px"> </span>

          <p class="!font-primary">{{ 'Collapse' | translate }}</p>
        </div>
      } @else {
        <div
          style="display: flex; justify-content: center; padding: 0px 8px; width: 47px"
          class="right-collapse"
          [matTooltip]="'Expand' | translate"
          [matTooltipPosition]="'right'"
        >
          <span class="icon right-arrow"> </span>
        </div>
      }
    </div>

    <div
      class="version-info"
      [matTooltip]="
        'Portal: ' +
        (versionService.frontendVersion() || '—') +
        '\n' +
        'API: ' +
        (versionService.backendVersion() || '—')
      "
      [matTooltipPosition]="'right'"
      matTooltipClass="version-tooltip"
    >
      {{ versionService.portalVersion() || 'version' }}
    </div>
  </mat-sidenav>
  <mat-sidenav-content [style.margin-left.px]="isCollapsed ? 80 : 275" style="transition: margin-left 0.3s ease">
    <div class="loading-bar-container">
      @if (loadingService.isLoading$ | async) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    @if (!errorMessage) {
      <router-outlet></router-outlet>
    } @else {
      <tfagency-error-message [errorMessage]="errorMessage" (retry)="reload()" />
    }
  </mat-sidenav-content>
</mat-sidenav-container>
